import { render } from "./TardyRadioGroupOld.vue?vue&type=template&id=7f5f8114"
import script from "./TardyRadioGroupOld.vue?vue&type=script&lang=js"
export * from "./TardyRadioGroupOld.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__